export const NATIONAL_ID_PATTERN = /^[A-Za-z0-9-]+$/;

export function splitRepresentativeName(fullName: string): { firstName: string; lastName: string } {
  const [firstName = "", ...rest] = fullName.trim().split(/\s+/);
  return { firstName, lastName: rest.join(" ") };
}
